import { Spin } from "antd";
import * as React from "react";

import * as styles from "./common.module.less";

/**
 * Компонент индикатора загрузки для таблицы
 */
export const TableLoading = () => (
  <div className={styles.loadingContent}>
    <Spin spinning size="large" />
  </div>
);
